import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

export default class Control extends React.Component {

    constructor(props) {
        super(props)

        const { field, forID, value, onChange } = props;

        this.state = {
            mediaControlId: "",
            insertPos: null,
            editor: null
        }

    }

    componentDidMount() {
        console.log(this.props);
        const { field, forID, value, onChange } = this.props;

        onChange(this.generateId())
    }

    static propTypes = {
        onChange: PropTypes.func.isRequired,
        forID: PropTypes.string,
        value: PropTypes.node,
        classNameWrapper: PropTypes.string.isRequired,
        onOpenMediaLibrary: PropTypes.func.isRequired,
    }

    generateId() {
        return Math.random().toString(36).substring(7);
    }

    shouldComponentUpdate(nextProps) {
        /**
         * Always update if the value or getAsset changes.
         */
        return true
    }

    log(msg) {
        console.log(msg)
    }

    render() {

        const button = {
        marginLeft: '1em',
        display: 'block',
        border: '0px',
        cursor: 'pointer',
        height: '27px',
        lineHeight: '27px',
        fontSize: '12px',
        fontWeight: 600,
        borderRadius: '3px',
        padding: '0px 14px',
        backgroundColor: 'rgb(121, 130, 145)',
        color: 'rgb(255, 255, 255)',
        marginRight: '8px',
        };

        const wrapper = {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            padding: '16px 20px',
            margin: '0px',
            border: '2px solid rgb(223, 223, 227)',
            borderRadius: '0px 5px 5px',
            outline: '0px',
            boxShadow: 'none',
            backgroundColor: 'rgb(255, 255, 255)',
            color: 'rgb(205, 205, 205)',
            transition: 'border-color 0.2s ease 0s',
            position: 'relative',
            fontSize: '15px',
        };

        const {
            value,
            onChange,
            forID,
        } = this.props;

        return (
            <div style={wrapper}>
                <input
                    type='hidden'
                    id={forID}
                    value={value}
                    onChange={(e) => onChange(e.target.value.trim())}>
                </input>
                    <span>
                        {value}
                    </span>
                    <button
                        onClick={() => {onChange(this.generateId());}}
                        style={button}>
                        Regenerate ID
                    </button>
            </div>
        )
    }
}